import { createGenericContext } from "../../../utils/createGenericContext";
export const [SelectedCiRelationsContext, useSelectedCiRelationsContext] = createGenericContext([]);
